import { Injectable } from '@angular/core';
import { Paho } from 'ng2-mqtt/mqttws31';

@Injectable({
  providedIn: 'root'
})
export class SendMessageService {

  constructor() { }
  sendMessage(client: Paho.MQTT.Client, message: string, topic: string) {
    const packet = new Paho.MQTT.Message(message);
    packet.destinationName = topic;
    client.send(packet);
  }
}
